import { differenceInMinutes } from "date-fns";

export const isFromLastXMinutes = (date: string, minutes: number): boolean => {
  const now = new Date();
  const minutesDifference = differenceInMinutes(now, new Date(date));

  return minutesDifference <= minutes;
};
